<template>
  <div
    class="m-tooltip"
    :class="{ 'm-tooltip--dark': darkMode }"
    @mouseenter="show"
    @mouseleave="onMouseLeave"
  >
    <button
      class="m-tooltip__button"
      ref="button"
      type="button"
      :aria-describedby="id"
      @focus="show"
      @blur="hide"
    >
      <slot name="action"></slot>
    </button>
    <div
      class="m-tooltip__content"
      :id="id"
      ref="tooltip"
      role="tooltip"
    >
      <div style="position: relative; width: 100%;">
        <div style="position: absolute; width: 100%; top: -8px; height: 3px;"></div>
      </div>

      <slot name="tooltip"></slot>
      <div class="m-tooltip__arrow" ref="arrow"></div>

      <div style="position: relative; width: 100%;">
        <div style="position: absolute; width: 100%; bottom: -8px; height: 3px;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import { createPopper } from '@popperjs/core'

export default {
  props: {
    darkMode:  {
      type: Boolean,
      default: false,
    },
    placement: {
      type: String,
      default: 'bottom',
    },
  },
  data() {
    return {
      id: "tooltip_" + uuidv4(),
      instance: null,
    }
  },
  mounted() {
    const offset = this.darkMode ? [0, 8] : [0, 3];

    this.instance = createPopper(this.$refs.button, this.$refs.tooltip, {
      placement: this.placement,
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: offset,
          },
        },
        {
          name: 'arrow',
          options: {
            element: this.$refs.arrow,
          },
        },
      ],
    });
  },
  methods: {
    onMouseLeave(event) {
      // Check if the new target is still inside the parent or child.
      if (!event.relatedTarget || (!event.currentTarget.contains(event.relatedTarget))) {
        this.hide()
      }
    },

    show() {
      this.$refs.tooltip.setAttribute('data-show', '');
      this.instance.update();
    },

    hide() {
      this.$refs.tooltip.removeAttribute('data-show');
    },
  },
}
</script>
